<template>
  <div class="wrapper">
    <div class="flex gap-3 ym-form p-5">
      <el-input v-model="searchValue" @input="searchInput" placeholder="请输入" clearable>
        <template #suffix>
          <el-icon color="#01AC68"><Search /></el-icon>
        </template>
      </el-input>
      <div style="width: 92px">
        <el-button class="ym-button" type="primary" plain @click="handleAdd">添加分类</el-button>
      </div>
    </div>
    <el-scrollbar class="flex-1 p-5 pt-0">
      <el-tree
        ref="treeRef"
        class="ym-tree"
        :current-node-key="props.modelValue"
        :data="props.data"
        :props="props.fieldNames"
        :node-key="props.nodeKey"
        @current-change="currentChange"
        :filter-node-method="filterNode">
        <template #default="{ node, data }">
          <div class="flex items-center justify-between w-full pr-5 gap-2 tree-item">
            <div class="flex items-center gap-1 flex-1" style="width: 0">
              <svg-icon name="file" style="min-width: 12px; height: 12px"></svg-icon>
              <span class="truncate">{{ node.label }}</span>
            </div>
            <div class="more-box">
              <el-dropdown :teleported="false" @command="handleCommand($event, data)">
                <span>
                  <svg-icon name="more" style="width: 16px; height: 16px; color: #01ac68"></svg-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="edit">
                      <svg-icon name="edit" style="width: 14px; height: 14px"></svg-icon>
                      <span class="ml-3">编辑分类</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="delete">
                      <svg-icon name="delete" style="width: 14px; height: 14px"></svg-icon>
                      <span class="ml-3">删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </template>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { TreeOptionProps } from 'element-plus'
import _ from 'lodash'

interface IProps {
  data: TreeOptionProps[]
  fieldNames?: {
    label: string
    children: string
  }
  nodeKey?: string
  modelValue: string
}
const props = withDefaults(defineProps<IProps>(), {
  fieldNames: () => {
    return {
      label: 'label',
      children: 'children'
    }
  },
  nodeKey: 'id'
})

const emits = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'handleAdd'): void
  (e: 'handleEdit', node: TreeOptionProps): void
  (e: 'handleDelete', node: TreeOptionProps): void
  (e: 'change', value: string): void
}>()

const searchValue = ref('')

const treeRef = ref()

function filterNode(value: string, data) {
  console.log('data :>> ', data)
  if (!value) return true
  return data[props.fieldNames.label].includes(value)
}

const searchInput = _.debounce((value) => {
  treeRef.value!.filter(value)
}, 500)

const currentChange = (node) => {
  emits('update:modelValue', String(node[props.nodeKey]))
  emits('change', String(node[props.nodeKey]))
}

const handleAdd = () => {
  emits('handleAdd')
}

const handleCommand = (cmd, data) => {
  if (cmd === 'edit') {
    emits('handleEdit', data)
  } else if (cmd === 'delete') {
    emits('handleDelete', data)
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
